const NoDetails = () => {
  return (
    <div className="flex h-full items-center justify-center">
      <p className="text-center text-neutral-9">Erstelle eine neue Ersatzteilanfrage oder wähle eine aus.</p>
    </div>
  );
};

export default NoDetails;
